import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, isSupportedLanguage } from '@/i18n';

/**
 * Arabic ⇄ English. Switching also flips `<html dir>` (handled in src/i18n), so the
 * whole layout mirrors — which is why physical Tailwind directions are a lint error.
 */
export function LanguageToggle() {
  const { t, i18n } = useTranslation();

  const current = isSupportedLanguage(i18n.resolvedLanguage ?? '')
    ? i18n.resolvedLanguage
    : DEFAULT_LANGUAGE;

  const next = SUPPORTED_LANGUAGES.find((lng) => lng !== current) ?? DEFAULT_LANGUAGE;

  return (
    <button
      type="button"
      onClick={() => void i18n.changeLanguage(next)}
      aria-label={t('common.switchTo', {
        language: next === 'ar' ? t('common.arabic') : t('common.english'),
      })}
      className="inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-sm font-medium text-slate-600 hover:bg-slate-100"
    >
      <Languages className="size-4" aria-hidden="true" />
      <span>{next === 'ar' ? t('common.arabic') : t('common.english')}</span>
    </button>
  );
}
